import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/products", label: "Products" },
  { to: "/offers", label: "Offers" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-white/90 backdrop-blur-md border-navy/10" : "bg-transparent border-transparent"
      }`}
    >
      <nav className={`max-w-[1400px] mx-auto px-4 md:px-8 flex items-center justify-between transition-all duration-300 ${scrolled ? "h-[72px]" : "h-[112px]"}`}>
        <Link to="/" data-testid="logo-link" className="flex flex-col leading-none text-left">
          <span className={`font-display font-black tracking-tight transition-all duration-300 ${scrolled ? "text-2xl md:text-3xl text-navy" : "text-4xl md:text-6xl text-white"}`}>SAYE IMPEX</span>
          <span className={`font-display font-bold tracking-[0.15em] transition-all duration-300 ${scrolled ? "text-[10px] md:text-xs text-navy mt-0.5" : "text-sm md:text-xl text-white mt-1.5"}`}>RECYCLING INC</span>
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`font-display font-bold uppercase tracking-wide transition-all duration-300 ${scrolled ? "text-base" : "text-lg"} ${
                scrolled ? "text-navy hover:text-emerald" : "text-white hover:text-emerald"
              } ${pathname === l.to ? "underline decoration-2 underline-offset-8" : ""}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/submit-offer"
            data-testid="nav-submit-offer"
            className={`font-display font-bold uppercase tracking-wide px-5 py-2.5 transition-all duration-300 ${scrolled ? "text-base" : "text-lg"} ${scrolled ? "bg-navy text-white hover:bg-emerald hover:text-navy" : "bg-white text-navy hover:bg-emerald"}`}
          >
            Submit Offer
          </Link>
        </div>

        <button
          className={`lg:hidden transition-colors ${scrolled ? "text-navy" : "text-white"}`}
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-navy/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`mnav-${l.label.toLowerCase()}`}
              className="font-mono text-sm uppercase tracking-widest text-navy">
              {l.label}
            </Link>
          ))}
          <Link to="/submit-offer" data-testid="mnav-submit-offer"
            className="bg-navy text-white font-mono text-sm uppercase tracking-widest px-5 py-3 text-center">
            Submit Offer
          </Link>
        </div>
      )}
    </header>
  );
};
